import React, { useCallback } from 'react';

import { useSelector } from 'react-redux';

import { Switch } from '../../../components';
import { i18n } from '../../../helpers/i18n';
import { useActions } from '../../../hooks';
import { selectJoinWithCameraOff, toggleJoinWithCameraOffAction } from '../../settings';
import css from './styles.css';

export const JoinWithCameraOffSwitch = () => {
    const actions = useActions({ toggleJoinWithCameraOffAction });

    const joinWithCameraOff = useSelector(selectJoinWithCameraOff);

    const onChange = useCallback(
        () => actions.toggleJoinWithCameraOffAction(!joinWithCameraOff),
        [actions, joinWithCameraOff]
    );

    return (
        <Switch
            labelBefore={i18n('settings', 'join-with-camera-off')}
            className={css.switch}
            checked={joinWithCameraOff}
            onChange={onChange}
            size="md"
            stretch
            shrink
        />
    );
};
